import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import SpyfallLobby from "./components/SpyfallLobby";
import SpyfallGame from "./components/SpyfallGame";
import Header from "./components/Header";
import PromptQuestionsLobby from "./components/PromptQuestionsLobby";
import PromptQuestionsGame from "./components/PromptQuestionsGame";
import Crossword from "./pages/Crossword";

function AppContent() {
  const location = useLocation();
  const hideHeader = location.pathname === "/crossword";

  return (
    <>
      {!hideHeader && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        {/* future routes */}
        <Route path="/spyfall" element={<SpyfallLobby />} />
        <Route path="/spyfall/game/:roomId" element={<SpyfallGame />} />
        <Route path="/promptquestions" element={<PromptQuestionsLobby />} />
        <Route path="/promptquestions/game/:roomId" element={<PromptQuestionsGame />} />
        <Route path="/crossword" element={<Crossword />} />
        <Route path="/mafia" element={<div>🔜 Mafia Lobby (coming soon)</div>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
